import { render, staticRenderFns } from "./ImportsDetail.vue?vue&type=template&id=d1e26c54&"
import script from "./ImportsDetail.vue?vue&type=script&lang=js&"
export * from "./ImportsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports